class Navigation extends HTMLElement {
  constructor() {
    super();
    const menu = this.getElementsByClassName('burger-menu')[0];
    const navbar = document.getElementById('navbar');
    const self = this;
    const accordions = this.getElementsByClassName('accordion');
    const links = this.getElementsByTagName('a');

    document.addEventListener('DOMContentLoaded', function () {
      Array.from(links).forEach((link) => {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          window.addToDataLayer('navigation_click', {
            eventCallback: function () {
              window.location = link.href;
            },
            eventTimeout: 2000,
          });
        });
      });
    });

    //Close menu with esc button
    const closeMenu = () => {
      self.classList.toggle('active');
      navbar.classList.toggle('active');
      menu.setAttribute('aria-expanded', self.classList.contains('active'));
      const panel = self.getElementsByClassName('nav-panel')[0];
      panel.classList.toggle('active');
      panel.classList.toggle('hidden');
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = 'max-content';
      }
    };

    menu.addEventListener('click', function () {
      self.classList.toggle('active');
      navbar.classList.toggle('active');
      menu.setAttribute('aria-expanded', self.classList.contains('active'));
      const panel = self.getElementsByClassName('nav-panel')[0];
      panel.classList.toggle('active');
      panel.classList.toggle('hidden');

      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        // panel.style.maxHeight = panel.scrollHeight + 150 + 'px';
        panel.style.maxHeight = 'max-content';
      }
    });

    // Mobile menu accordions
    const mediaQuery = window.matchMedia('(max-width: 1023px)');

    if (mediaQuery.matches) {
      Array.from(accordions).forEach((accordion) => {
        const panelAccId = accordion.getAttribute('aria-controls');
        const panelAcc = document.getElementById(panelAccId);

        accordion.addEventListener('click', function () {
          const isExpanded = accordion.getAttribute('aria-expanded') === 'true';

          accordion.setAttribute('aria-expanded', !isExpanded);

          const focusableElements = panelAcc.querySelectorAll('a, [tabindex]');
          focusableElements.forEach((element) => {
            if (isExpanded) {
              element.setAttribute('tabindex', '0');
            } else {
              element.removeAttribute('tabindex');
            }
          });

          if (isExpanded) {
            panelAcc.classList.add('active');
            panelAcc.classList.remove('hidden');
          } else {
            panelAcc.classList.remove('active');
            panelAcc.classList.add('hidden');
          }
        });

        // Initialize the panel to be inaccessible by default
        const focusableElements = panelAcc.querySelectorAll('a, [tabindex]');
        focusableElements.forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && self.classList.contains('active')) {
        closeMenu();
      }
    });
  }
}

customElements.define('navigation-element', Navigation);
